/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryModifierAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class SummaryQueryModifierAPI {

		/**
		 * @function SummaryQueryModifierAPI#addDataItemIdList
		 * @description add the data item ID list so query can be modified based on this list
		 * @public
		 * @param {String[]} dataItemIdList Array of data item IDs used to modify the query.
		 */
		addDataItemIdList() {}

		/**
		 * @function SummaryQueryModifierAPI#resetDataItemIdList
		 * @description reset the Array of data item IDs used to modify the query to empty
		 * @public
		 */
		resetDataItemIdList() {}
	}
	return SummaryQueryModifierAPI;
});
